import React from "react";
import { Form, Button } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import useAppStore from "../../../store/global";
import { useFetchReportNamesForPoS } from "../../Home/api";
export default function Uploader({
  handleUpload,
  fetchInstructions,
  instructionLoading,
  instructions,
  scrapperProcesses,
}) {
  const [reportType, setReportType] = React.useState("");
  const [extractionType, setExtractionType] = React.useState("default");
  const [file, setFile] = React.useState(null);
  const [date, setDate] = React.useState("");
  const { id } = useParams();
  const { loading } = useAppStore();
  const [selectedPos, setSelectedPos] = React.useState(null);
  const [selectedPosName, setSelectedPosName] = React.useState(null);
  const [selectedPosId, setSelectedPosId] = React.useState(null);
  const [posName, setPosName] = React.useState(null);
  const handlePosChange = (e) => {
    const value = JSON.parse(e.target.value);
    setSelectedPos((prevSelectedPos) =>
      prevSelectedPos === value.job_id ? null : value.job_id
    );
    setSelectedPosId((prevSelectedPosId) =>
      prevSelectedPosId === value.pos_id ? null : value.pos_id
    );
    setPosName((prevPosName) =>
      prevPosName === value.pos_name ? null : value.pos_name
    );
  };

  const { data, isLoading, isError } = useFetchReportNamesForPoS(selectedPosId);

  const handleSubmit = (event) => {
    event.preventDefault();
    const body = {
      restaurant_id: id,
      job_id: selectedPos,
      report_type: reportType,
      pos_name: selectedPosName,
    };
    fetchInstructions(body);
  };

  const handleUploadSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData();
    formData.append("file", file);
    const body = {
      restaurant_id: id,
      job_id: selectedPos,
      report_type: reportType,
      report_date: date,
      extraction_type: extractionType,
      pos_name: posName,
    };
    formData.append("data", JSON.stringify(body));
    handleUpload(formData);
  };

  return (
    <div className="mx-md-5 shadow-lg p-3 mb-5 bg-body rounded">
      <Form onSubmit={handleSubmit}>
        <Form.Group className="my-2">
          <Form.Label>Select Data Extraction Platform</Form.Label>
          {scrapperProcesses.map((pos) => (
            <Form.Check
              key={pos.job_id}
              type="radio"
              label={pos.pos_name}
              value={JSON.stringify(pos)}
              checked={selectedPos === pos.job_id}
              onChange={handlePosChange}
            />
          ))}
        </Form.Group>
        <Form.Group controlId="reportType">
          <Form.Label>Select Report Type</Form.Label>
          <Form.Control
            as="select"
            value={reportType}
            onChange={(e) => setReportType(e.target.value)}
            style={{
              width: "75%",
            }}
          >
            <option value="all">Select a report type</option>
            {isLoading && <option value="loading">Loading...</option>}
            {isError && <option value="error">Error fetching data</option>}
            {data &&
              data?.report_names?.map((report) => (
                <option
                  key={report}
                  value={report}
                  style={{ textTransform: "capitalize" }}
                >
                  {report}
                </option>
              ))}
          </Form.Control>
        </Form.Group>

        <Button
          className="my-2"
          variant="primary"
          type="submit"
          style={{
            width: "75%",
          }}
          disabled={instructionLoading}
        >
          {instructionLoading ? "Fetching..." : "Get Instructions"}
        </Button>
      </Form>
      <div
        style={{
          width: "75%",
          marginTop: "20px",
        }}
      >
        {instructionLoading ? (
          <div className="d-flex justify-content-center align-items-center">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : (
          <div>Instructions: {instructions}</div>
        )}
      </div>
      <div
        style={{
          width: "75%",
          marginTop: "40px",
        }}
        className="shadow-lg p-3 mb-5 bg-body rounded"
      >
        <Form onSubmit={handleUploadSubmit}>
          <Form.Group controlId="reportType">
            <Form.Label>Upload Report File</Form.Label>
            <Form.Control
              type="file"
              onChange={(e) => setFile(e.target.files[0])}
              style={{
                width: "75%",
              }}
            />
          </Form.Group>
          <Form.Group controlId="reportType">
            <Form.Label>Select Extraction Type</Form.Label>
            <Form.Control
              as="select"
              value={extractionType}
              onChange={(e) => setExtractionType(e.target.value)}
              style={{
                width: "75%",
                textTransform: "capitalize",
              }}
            >
              {["default", "onboarding", "classification"]?.map((report) => (
                <option
                  key={report}
                  value={report}
                  style={{ textTransform: "capitalize" }}
                >
                  {report}
                </option>
              ))}
            </Form.Control>
          </Form.Group>

          <Form.Group controlId="reportDate">
            <Form.Label>Select Report Date</Form.Label>
            <Form.Control
              type="date"
              onChange={(e) => setDate(e.target.value)}
              style={{
                width: "75%",
              }}
            />
          </Form.Group>
          <Button
            className="my-2"
            variant="success"
            type="submit"
            style={{
              width: "75%",
            }}
            disabled={loading || file === null}
          >
            {loading ? "Uploading..." : "Upload"}
          </Button>
        </Form>
      </div>
    </div>
  );
}
